import reduceer from "./reducers";
import { combineReducers } from "redux";
const rootReducer=combineReducers({
    red1:reduceer
})
export default rootReducer